import React, { Component } from 'react';
import moment from 'moment';
import Fade from 'react-reveal/Fade';

import './style.scss';

class Event extends Component {
	formatDate = (date) => {
		return moment(date).format('MM.DD');
	};

	formatDay = (day) => {
		return moment(day).format('ddd');
	};

	formatTime = (time) => {
		// return moment(time).format('ha');
		return time;
	};

	render() {
		const { data, vendor, icon } = this.props,
			{ date, start, end } = data;

		return (
			<article className="event">
				<div className="wrapper">
					<Fade top>
						<div className="event__food">
							<p className="event__food--link">{vendor.handle}</p>
							<p className="event__food--name">{vendor.name}</p>
							<p className="event__food--time">
								{this.formatTime(start)} - {this.formatTime(end)}
							</p>
						</div>
						<div className="event__date">{this.formatDate(date)}</div>
						<div className="event__day">{this.formatDay(date)}</div>
						<div className="event__icon">
							<img src={icon} alt={vendor.name} height="95" />
						</div>
					</Fade>
				</div>
			</article>
		);
	}
}

export default Event;



// WEBPACK FOOTER //
// ./src/components/event/index.js